// src/stores/workerStore.js
import { defineStore } from 'pinia'

export const useWorkerStore = defineStore('worker', {
  state: () => ({
    workerInstance: null,
    meta: {
      senderId: null,
      appId: window.hkConfigEnvs.VUE_APP_NAME
    }
  }),
  actions: {
    saveWorkerInstance(instance) {
      this.workerInstance = instance.value
    },
    saveMainDatatoWorker(payload) {
      this.meta = {...payload}
    },
  },
})
